import apiClient from '../apiClient';
import { GET_ACCOMODATION_FACILITIES_URL } from '../apiUrl';

const getAccomodationFacilitiesApi = () => {
  return apiClient.get(GET_ACCOMODATION_FACILITIES_URL);
};

export default getAccomodationFacilitiesApi;
